<template>
    <div v-if="loaded">
        <div class="topbar">
            <div class="topbar__inner">
                <ul class="topbar__side">
                    <li>
                        <div class="mt-4">
                            <b-dropdown id="dropdown-1" text="Actions" class="topbar__side__actions">
                                <b-dropdown-item v-if="false" class="action">
                                  <font-awesome-icon :icon="['fa', 'tags']" />
                                  Add Tags
                                </b-dropdown-item>

                                <b-dropdown-item class="action">
                                  <font-awesome-icon :icon="['fa', 'file-pdf']" />
                                    <a @click="generateReport">Export PDF</a>
                                </b-dropdown-item>
                                <b-dropdown-item class="action">
                                  <font-awesome-icon :icon="['fa', 'file-csv']" />
                                    <a @click="exportContacts">Export Contacts CSV</a>
                                </b-dropdown-item>
                                <b-dropdown-item class="action icons-list__report">
                                    <a @click="$refs.errorReport.open()">Report Incorrect Data</a>
                                </b-dropdown-item>
                                <b-dropdown-item class="action icons-list__invite" v-if="!commonData.has_account">
                                    <a @click="$refs.invite.open(id)">Invite Startup To Edit Profile</a>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <main class="main main--details">
            <aside class="aside aside--details">
                <div class="aside__inner">
                    <div class="image-block image-block--lg">
                        <img :src="LogoHelper.getLogo(commonData.logo_url)" alt="img"/>
                    </div>
                    <h2 class="heading2">{{commonData.name}}</h2>
                    
                    <div v-if="false" class="type-label">Buzzing</div>
                    
                    <div class="aside--details__description mt-3">
                        <p>{{ commonData.short_description }} <a v-if="commonData.description && (commonData.short_description != commonData.description)" id="show-description" class="link">(more)</a></p>
                    </div>

                    <b-popover v-if="commonData.short_description != commonData.description" ref="descriptionPopover" target="show-description">
                        <div class="popover__content" v-click-outside="closeDescriptionPopover">
                            {{commonData.description}}
                        </div>
                    </b-popover>
                    
                    <h4 class="heading4 heading4--tertiary">
                        Overview
                        <a v-if="false" class="heading-edit"></a>
                    </h4>

                    <ul class="overview-list">
                        <li v-if="commonData.website.length">
                            <a :href="commonData.website" target="_blank">
                                <font-awesome-icon :icon="['fa', 'globe']" />
                                {{ commonData.url_domain }}
                            </a>
                        </li>
                        <li v-if="commonData.total_raised > 0">
                            <a v-if="fundingRounds.length" class="d-flex align-items-center" @click="showFundingRounds"><span class="overview-list__icon icon-funding"></span>{{stringHelper.formatNumber(commonData.total_raised)}} raised</a>
                            <span v-else class="d-flex align-items-center"><span class="overview-list__icon icon-funding"></span>{{stringHelper.formatNumber(commonData.total_raised)}} raised</span>
                        </li>
                        <li v-if="commonData.revenue_range"><span class="overview-list__icon icon-income"></span> {{ revenueRange }} Annual Income</li>
                        <li v-if="commonData.employees"><font-awesome-icon :icon="['fa', 'users']" />{{ commonData.employees }} Employees</li>
                        <li v-if="location"><font-awesome-icon :icon="['fa', 'map-marker-alt']" /> {{ location }}</li>
                        <li v-else-if="commonData.crunch_status == 2 && commonData.diffbot_status != 1"><a class="link" @click="$refs.SetLocation.open()">+ Add Location</a></li>
                        <li v-if="commonData.stage"><span class="overview-list__icon icon-sturtups"></span> {{ commonData.stage }}</li>
                        <li v-if="commonData.founded"><span class="overview-list__icon icon-founded"></span> Founded {{ commonData.founded }}</li>
                    </ul>
                    
                    <ul v-if="commonData.linkedin_url || commonData.twitter_url || commonData.facebook_url" class="social-list">
                        <li v-if="commonData.linkedin_url">
                            <a :href="commonData.linkedin_url">
                                <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                            </a>
                        </li>
                        <li v-if="commonData.twitter_url">
                            <a :href="commonData.twitter_url">
                                <font-awesome-icon :icon="['fab', 'twitter']" />
                            </a>
                        </li>
                        <li v-if="commonData.facebook_url">
                            <a :href="commonData.facebook_url">
                                <font-awesome-icon :icon="['fab', 'facebook-square']" />
                            </a>
                        </li>
                    </ul>
                    <a class="copy-link" @click="copyProfileLink">Copy profile link</a>

                    <template v-if="commonData.categories.length || commonData.crunch_status == 2 && commonData.diffbot_status != 1">
                        <h4 class="heading4 heading4--tertiary">
                            Categories
                        </h4>
                        <div class="mb-4">
                            <div v-if="commonData.categories.length" class="tags-list tags-list--light mb-1">
                                <span v-for="category in commonData.categories" :key="category.id" class="tags-list__tag" :title="category.name">{{ category.name }}</span>
                            </div>

                            <a class="link" v-if="commonData.crunch_status == 2 && commonData.diffbot_status != 1" @click="$refs.SelectCategories.open()">+ Add Categories</a>
                        </div>
                    </template>

                    <h4 class="heading4 heading4--tertiary">
                        About
                        <a v-if="false" class="heading-edit"></a>
                    </h4>
                    <p>
                        <template v-if="commonData.provided_by == 'crunchbase'">
                            Data provided by Crunchbase<br>
                            Updated {{ dateHelper.decodeDate(commonData.last_crunchbase_sync_date) }}
                        </template>
                        <template v-else-if="commonData.provided_by == 'community'">
                            Data provided by SwitchPitch community members
                        </template>
                        <template v-else>
                            Data provided by SwitchPitch
                        </template>
                        <template v-if="typeof commonData.user_added !== 'undefined'">
                            <br> Added by {{ commonData.user_added.name}}
                            <Avatar v-if="false"
                                    :username="commonData.user_added.name"
                                    :src="commonData.user_added.avatar"
                                    :size="30">
                            </Avatar>

                        </template>
                    </p>



                    <p>Data incorrect? <a class="link" @click="$refs.errorReport.open()">Contact us</a></p>

<!--                    <a class="link" href="#">More</a>-->
                    <template v-if="commonData.website_keywords.length" class="mt-2">
                        <div class="accordion mt-4">
                            <header class="accordion__header" v-b-toggle.accordion-1 >
                                <h4 class="accordion__title heading4 heading4--tertiary mb-0">Website Keywords</h4>
                            </header>
                            <b-collapse id="accordion-1" accordion="my-accordion" >
                                <div class="tags-list tags-list--light">
                                      <router-link :to="'/startups?keywords=' + keyword" v-for="keyword in commonData.website_keywords" :key="keyword" class="tags-list__tag" :title="keyword">
                                         <v-clamp autoresize :max-lines="1">{{ keyword }}</v-clamp>
                                      </router-link>
                                </div>
                            </b-collapse>
                        </div>
                    </template>


                </div>
            </aside>

            <div class="content">
                <b-tabs class="tabs-primary" content-class="mt-3">

                    <b-tab class="tab-pane--sticky" active>
                        <template #title>
                            Activity
                            <small>{{activities.length}} updates</small>
                        </template>
                        
                        <!--.dashboard.dashboard--tasks .dashboard__content .main-table-wrapper-->

                        <div class="form-add activity-notes-section">
                            <div class="activity-notes-list">
                                <a @click="interactionType = 'note'" class="activity-notes-list__note" :class="{active: interactionType == 'note'}">Note</a>
                                <a @click="interactionType = 'meeting'" class="activity-notes-list__meeting" :class="{active: interactionType == 'meeting'}">Meeting</a>
                                <a @click="interactionType = 'email'" class="activity-notes-list__email" :class="{active: interactionType == 'email'}">Email</a>
                                <a @click="interactionType = 'phone_call'" class="activity-notes-list__call" :class="{active: interactionType == 'phone_call'}">Call</a>
                                <a @click="interactionType = 'news'" class="activity-notes-list__news" :class="{active: interactionType == 'news'}">News</a>
                            </div>
                            
                            <div class="activity-notes-section__form">
                                <AddNote
                                    v-if="interactionType == 'note'"
                                    companyType="startup"
                                    :companyId="id"
                                    v-on:saved="activitySaved"
                                >
                                </AddNote>
    
                                <AddInteraction
                                    v-if="['phone_call','email','meeting'].includes(interactionType)"
                                    :type="interactionType"
                                    companyType="startup"
                                    :companyId="id"
                                    :usersMentionList="usersMentionList"
                                    v-on:saved="activitySaved"
                                >
                                </AddInteraction>
    
                                <AddArticle
                                    v-if="interactionType == 'news'"
                                    :startup-id="id"
                                    v-on:saved="activitySaved"
                                >
                                </AddArticle>
                            </div>
                        </div>


                        <div class="accordion accordion--secondary accordion--tabs">
                            <div class="accordion__header-wrapper">
                                <div class="tasks__select" v-click-outside="function() {openActivityFilterSelect = false}">
                                    <div @click="openActivityFilterSelect = true" class="tasks__select__chosen">
                                        <span :title="activityFilterTypes[activityFilter]">{{activityFilterTypes[activityFilter]}}</span>
                                    </div>
                                    <ul v-show="openActivityFilterSelect" class="multiselect__content">
                                        <li class="multiselect__element" v-for="(name, value) in activityFilterTypes" :key="value" @click="activityFilter = value; openActivityFilterSelect = false; getActivities()">{{name}}</li>
                                    </ul>
                                </div>
    
                                <div v-if="activityFilter == 'interactions'" class="tasks__select" v-click-outside="function() {openActivityOrderSelect = false}">
                                    <div @click="openActivityOrderSelect = true" class="tasks__select__chosen">
                                        <span :title="activityOrderTypes[activityOrder]">{{activityOrderTypes[activityOrder]}}</span>
                                    </div>
                                    <ul v-show="openActivityOrderSelect" class="multiselect__content multiselect__content--date">
                                        <li class="multiselect__element" v-for="(name, value) in activityOrderTypes" :key="value" @click="activityOrder = value; openActivityOrderSelect = false; getActivities()">{{name}}</li>
                                    </ul>
                                </div>
                            </div>

                            <b-collapse visible id="collapse-3">
                                <ul class="activity-list action-logs-list">
                                    <li v-for="(activity, index) in activities" :key="index">
                                        <div class="activity-list__author">
                                            <div class="image-block image-block--rounded image-block--rounded--md">
                                                <Avatar v-if="activity.user_name=='SwitchPitch'"
                                                    background-color="#043648"
                                                    color="#00AFEF"
                                                    initials="SP"
                                                    :size="56"
                                                ></Avatar>
                                                <Avatar v-else
                                                    :username="activity.user_name"
                                                    :src="activity.user_avatar"
                                                    :size="56"
                                                ></Avatar>
                                            </div>
                                            <div>
                                                <h5 class="heading5 heading5--secondary" :class="{'deleted': activity.user_deleted}">{{activity.user_name}} <template v-if="activity.user_deleted">(D)</template> </h5>
                                                <time class="activity-list__time">{{dateHelper.decodeDate(activity.date)}}</time>
                                            </div>
                                        </div>

                                        <div class="activity-list__content">
                                            <h5 class="activity-list__title" :class="getActivityIconClass(activity)">{{ activity.title }} <span style="font-weight: normal;"><template v-if="activity.interaction_date">(Interaction Date: {{dateHelper.decodeDate(activity.interaction_date)}})</template></span></h5>
                                            <div class="activity-list__text" v-html="activity.text"></div>

                                            <template v-if="typeof activity.tag !== 'undefined'">
                                                <div class="tags-list tags-list--light">
                                                    <div class="tags-list__tag">
                                                        <a :href="'/startups?tag=' + activity.tag" target="_blank">{{activity.tag}}</a>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-if="typeof activity.tracker !== 'undefined'">
                                                <div class="action-logs-list__trackers">
                                                    <div class="tags-list tags-list--light pt-0">
                                                        <a class="tags-list__tag" :href="'/trackers/' + activity.tracker.id" target="_blank">{{activity.tracker.name}}</a>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-if="typeof activity.contact !== 'undefined'">
                                                <div class="action-logs-list__user-inner">
                                                    {{activity.contact}}
                                                </div>
                                            </template>

                                            <template v-if="typeof activity.task !== 'undefined'">
                                                <div class="action-logs-list__tasks">
                                                    <div class="action-logs-list__task">
                                                        <a :href="'/?open_task=' + activity.task.id" target="_blank">{{activity.task.name}}</a>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-if="typeof activity.custom_value !== 'undefined'">
                                                <div class="action-logs-list__custom">
                                                    <b>{{activity.custom_value.field}}</b>
                                                    <template v-if="activity.custom_value.value.length">: <span v-html="activity.custom_value.value"></span></template>
                                                </div>
                                            </template>

                                            <template v-if="typeof activity.file !== 'undefined'">
                                                <div class="action-logs-list__file-wrapper">
                                                    <div class="action-logs-list__file">
                                                        {{ activity.file }}
                                                    </div>
                                                </div>
                                            </template>
                                        </div>

                                        <template v-if="activity.object_type == 'news'">
                                            <b-dropdown v-if="activity.can_edit" right class="dropdown-single dropdown-single--big ml-auto btn-group icons-list pl-5">
                                                <b-dropdown-item class="icons-list__edit" @click="editArticle(activity.object_id)">
                                                    Edit Article
                                                </b-dropdown-item>
                                                <b-dropdown-item class="icons-list__delete2" @click="removeArticle(activity.object_id)">
                                                    Delete Article
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </template>

                                        <template v-if="['startup-note','interaction'].includes(activity.object_type)">
                                            <b-dropdown right class="dropdown-single dropdown-single--big ml-auto btn-group drag-n-drop icons-list pl-4">
                                                <b-dropdown-item class="icons-list__edit" v-if="activity.can_edit" @click="editActivity(activity)">
                                                    Edit
                                                </b-dropdown-item>
                                                <b-dropdown-item class="icons-list__delete2" v-if="$store.state.user.is_admin || (activity.type == 'note' && activity.user_id == $store.state.user.id)" @click="removeActivity(activity.log_id)">
                                                    Remove
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </template>
                                    </li>
                                </ul>
                            </b-collapse>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            Details
                            <small v-if="filledFieldsPerc !== null">{{ filledFieldsPerc }}% of filled fields</small>
                        </template>

                        <div class="details-field accordion">
                            <div v-for="(item, index) in ecosystemsData" :key="index">
                                <header class="details-field__header accordion__header" v-b-toggle="'accordion-ecosystem-' + index">
                                    <h4 class="heading4 accordion__title">{{item.name}} Notes</h4>
                                </header>

                                <b-collapse :id="'accordion-ecosystem-' + index" accordion="sections-accordion">
                                    <table class="details-table">
                                        <tr>
                                            <td>
                                                Description
                                            </td>

                                            <td v-html="item.text">

                                            </td>
                                        </tr>
                                    </table>
                                </b-collapse>
                            </div>

                            <div v-for="(section, sectionId) in customFields" :key="sectionId">
                                <header class="details-field__header accordion__header" v-b-toggle="'accordion-' + sectionId">
                                    <h4 class="heading4 accordion__title">{{section.name}}</h4>

                                    <a v-if="false" class="details-field__manage" href="/settings/custom-fields">Manage</a>

                                    <div class="section-users ml-auto">
                                        <div class="section-users__images">
                                            <div v-for="(avatar, index) in stringHelper.getAvatarsForDisplay(section.permissions)" :key="index" class="section-users__images__item">
                                                <img :src="avatar" style="width: 30px;" alt=""/>
                                            </div>
                                        </div>

                                        <p>
                                            <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(section.permissions)" :key="index">
                                                {{item}}
                                            </a>
                                        </p>
                                    </div>

                                </header>

                                <b-collapse :id="'accordion-' + sectionId" accordion="sections-accordion" :visible="Object.keys(customFields)[0] == sectionId">
                                    <table class="details-table">
                                        <tr v-for="field in section.fields" :key="field.id">
                                            <td colspan="2" v-if="field.type == 'static_text'">
                                                {{field.name}}
                                            </td>
                                            <td v-else>
                                                {{field.name}}
                                            </td>

                                            <td v-if="field.type != 'static_text'">
                                                <custom-field
                                                    :disabled="!field.can_edit"
                                                    :editable="field.can_edit"
                                                    :field="field"
                                                    :value="customData[field.id]"
                                                    :startupId="id"
                                                    v-on:valueChanged="customValueChanged(field.id)"
                                                >
                                                </custom-field>
                                            </td>
                                        </tr>

                                        <tr v-if="section.is_default">
                                            <td>
                                                Tags
                                            </td>
                                            <td>
                                                <div class="tags-list tags-list--light">
                                                <span v-for="tag in tags" :key="tag.id" class="tags-list__tag" :title="tag.name">
                                                    <a :href="'/startups?tag=' + tag.name" target="_blank">{{ tag.name }}</a>
                                                    <a class="tags-list__tag__close" @click="removeTag(tag.id)"></a>
                                                </span>

                                                    <a v-if="addTagsList.length" @click="openAddTags" class="link">+ Add tags</a>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </b-collapse>
                            </div>
                        </div>

                    </b-tab>

                    <b-tab>
                        <template #title>
                            Trackers
                            <small>{{ trackers.length }} tracker(s)</small>
                        </template>

                        <div class="tabs-primary__inner">

                            <header class="main-inner__header text-right mb-2">
                                <a class="link link--xl" @click="openAddToTrackers">+ Add To A Tracker</a>
                            </header>

                            <table class="main-table" v-if="trackers.length">
                                <thead>
                                <tr>
                                    <th>Tracker Name</th>
                                    <th class="main-table__auto">Description</th>
                                    <th class="main-table__auto">Startups</th>
                                    <th class="main-table__auto">Type</th>
                                    <th class="main-table__auto">Funnel stage</th>
                                    <th>Permissions</th>
                                    <th class="main-table__auto">Last Modified</th>
                                    <th class="main-table__auto">Actions</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="tracker in trackers" :key="tracker.id">
                                    <td><a :href="'/trackers/' + tracker.id">{{ tracker.name }}</a></td>
                                    <td v-html="tracker.description"></td>
                                    <td>{{ tracker.startups_count }}</td>
                                    <td>{{ constants.trackerTypes[tracker.type] }}</td>
                                    <td>{{ tracker.stage }}</td>
                                    <td>
                                        <b-dropdown class="dropdown--secondary ml-auto" variant="link" toggle-class="text-decoration-none" no-caret>
                                            <template #button-content>
                                                <div class="section-users flex-nowrap mr-2">
                                                    <div class="section-users__images">
                                                        <div v-for="(permission, index) in tracker.permissions" :key="index" class="section-users__images__item">
                                                            <img v-if="permission.type == 'user' && permission.avatar.length" :src="permission.avatar" style="width: 30px;" alt=""/>
                                                        </div>
                                                    </div>

                                                    <p>
                                                        <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(tracker.permissions)" :key="index">
                                                            {{item}}
                                                        </a>
                                                    </p>
                                                </div>
                                            </template>

                                            <b-dropdown-header>
                                                <header class="dropdown__header-inner">
                                                    <h4 class="heading4">Users in {{ tracker.name }}</h4>

                                                    <a v-if="false" href="#" class="link link--lg">Edit</a>
                                                </header>

                                                <ul class="rows-list">
                                                    <li  v-for="(permission, index) in tracker.permissions" :key="index">
                                                        <div class="rows-list__avatar">
                                                            <Avatar
                                                                :username="permission.name"
                                                                :src="permission.avatar"
                                                                :size="30">
                                                            </Avatar>
                                                        </div>

                                                        <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>

                                                        <!-- Please add here the logic first -->
                                                        <p class="ml-auto">{{ permission.role.name }}</p>
                                                        <a class="link-info" href="#">
                                                            <span class="link-info__content">Can view and edit all information, and can delete and archive items</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </b-dropdown-header>
                                        </b-dropdown>
                                    </td>
                                    <td>
                                        {{tracker.last_modified}}
                                    </td>
                                    <td>
                                        <div class="card flex-row" v-if="tracker.user_can_manage_startups && tracker.type != 'public'">
                                            <b-dropdown class="ml-5 drag-n-drop icons-list dropdown-simple dropdown-small" boundary="viewport">
                                                <b-dropdown-item class="icons-list__edit" @click="removeFromTracker(tracker.id)">
                                                    Remove From Tracker
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <AddToTrackers
                                ref="addToTrackers"
                                :trackers-list="otherTrackersList"
                                v-on:trackersSelected="addToTrackers"
                            >
                            </AddToTrackers>

                            <edit-tracker
                                ref="editTracker"
                                :folder-id="id"
                                v-on:trackerSaved="getTrackers"
                            >
                            </edit-tracker>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            Contacts
                            <small>{{contactsTotalCount}} total</small>
                        </template>
                        <div class="tabs-primary__inner">
                            <div class="d-flex align-items-center justify-content-between flex-wrap mb-4">
                                <div class="form-search form-search--mid mb-3 mb-sm-0">
                                    <input type="text" v-model="contactsSearch" placeholder="Search by name or title"/>
                                </div>
                                <a @click="addContact" class="link link--xl">+ Add A Contact</a>
                            </div>

                            <ul class="list-contacts">
                                <li v-for="contact in contacts" :key="contact.id" @click="showContactInfo(contact.id)">
                                    <div class="card card--bordered card--centered" :class="{'card--rated': contact.is_primary}">
                                        <b-dropdown class="drag-n-drop icons-list dropdown-simple dropdown-small position-absolute" boundary="viewport">
                                            <b-dropdown-item v-if="contact.custom && contact.can_edit" class="icons-list__delete" @click.stop="deleteContact(contact.id)">
                                                Delete Contact
                                            </b-dropdown-item>

                                            <b-dropdown-item v-if="!contact.custom" class="icons-list__edit" @click.stop="editContact(contact.id)">
                                                Edit Contact
                                            </b-dropdown-item>
                                        </b-dropdown>

                                        <div class="image-block image-block--rounded--lg">
                                            <Avatar
                                                :username="contact.name"
                                                :src="contact.avatar"
                                                :size="75"
                                            >
                                            </Avatar>
                                        </div>
                                        <h5 class="heading5">{{ contact.name }}</h5>
                                        <p>{{ contact.job_title }}</p>
                                    </div>
                                </li>
                            </ul>

                            <edit-contact
                                ref="editContact"
                                v-on:contactSaved="getContacts(); getActivities()"
                            >
                            </edit-contact>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            Tasks
                            <small>{{tasksCount}} total</small>
                        </template>

                        <div class="tabs-primary__inner">
                            <table class="header-table">
                                <tr>
                                    <td>
                                        <h4 class="heading4 d-flex">Tasks Assigned to
                                            <div class="tasks__select" v-click-outside="function() {openTasksTypeSelect = false}">
                                                <div @click="openTasksTypeSelect = true" class="tasks__select__chosen">
                                                    <span>{{taskListTypes[tasksListType]}}</span>
                                                </div>
                                                <ul v-show="openTasksTypeSelect">
                                                    <li v-for="(name, value) in taskListTypes"  :key="value" @click="tasksListType = value; openTasksTypeSelect = false">{{name}}</li>
                                                </ul>
                                            </div>
                                        </h4>
                                    </td>
                                    <td>
                                        <div class="dashboard--tasks__controls">
                                            <input class="form-search-primary" type="text" v-model="taskSearch" placeholder="Search tasks"/>

                                            <a @click="$refs.addTask.open(0)" class="dashboard--tasks__add ml-4">+ Add A Task</a>
                                            <div class="card m-0 py-0">
                                                <b-dropdown  class="drag-n-drop icons-list dropdown-simple " boundary="viewport">
                                                    <b-dropdown-item class="icons-list__show" v-if="!tasksShowCompleted" @click="tasksShowCompleted = true">Show completed</b-dropdown-item>
                                                    <b-dropdown-item class="icons-list__hide" v-if="tasksShowCompleted" @click="tasksShowCompleted = false">Hide completed</b-dropdown-item>
                                                    <b-dropdown-item class="icons-list__csv" @click="exportTasks">Export CSV</b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div class="dashboard dashboard--tasks pt-2">
                                <div class="dashboard__content px-0">
                                    <TasksList
                                        ref="tasksList"
                                        :list-type="tasksListType"
                                        :search="taskSearch"
                                        :show-completed="tasksShowCompleted"
                                        :startup-id="id"
                                    >
                                    </TasksList>
                                </div>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            Related
                            <small v-if="investors.length">{{ investors.length }} investor(s),</small> <small>{{ commonData.ecosystems.length }} ecosystem(s)</small>
                        </template>

                        <div class="tabs-primary__inner">

                            <template v-if="investors.length">
                                <h2 class="heading2 mb-4">Investors</h2>

                                <div class="main-table-wrapper mb-5">
                                    <table class="main-table">
                                        <thead>
                                        <tr>
                                            <th>
                                                <div class="main-table__title">
                                                    Company
                                                </div>
                                            </th>
                                            <th>
                                                <div class="main-table__title">
                                                    Rounds Funded
                                                </div>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(investor, index) in investors" :key="index">
                                            <td>
                                                {{investor.name}}
                                            </td>
                                            <td>
                                                {{stringHelper.formattedFundingSeriesArray(investor.funding_types).join(', ')}}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>

                            <template v-if="commonData.ecosystems.length">
                                <h2 class="heading2 mb-4">Ecosystems</h2>

                                <div class="main-table-wrapper mb-5">
                                    <table class="main-table">
                                        <thead>
                                            <tr>
                                                <th>Company</th>
                                                <th>Location</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="ecosystem in commonData.ecosystems" :key="ecosystem.id">
                                                <td>
                                                    <div class="main-table__data" style="width: auto;">
                                                        <div class="image-block">
                                                            <img :src="LogoHelper.getLogo(ecosystem.logo_url)" alt=""/>
                                                        </div>
                                                        <div>
                                                            <h5 class="heading5 mb-0">
                                                                <a :href="'/ecosystems/' + ecosystem.id" target="_blank">{{ ecosystem.name }}</a>
                                                            </h5>
                                                            <v-clamp autoresize :max-lines="3"> {{ecosystem.description }}
                                                                <template #after="{ toggle, expanded, clamped }">
                                                                    <a v-if="expanded" class="link-normal" @click="toggle"> less</a>
                                                                    <a v-if="clamped" class="link-normal" @click="toggle"> more</a>
                                                                </template>
                                                            </v-clamp>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{{ ecosystem.location }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </main>

        <AddTags
            ref="addTags"
            :tags-list="addTagsList"
            v-on:addTags="addTags"
        >
        </AddTags>

        <FundingRounds
            ref="fundingRounds"
            :init-funding-rounds="fundingRounds"
        >
        </FundingRounds>

        <PdfLayout
            ref="pdfLayout"
            :startups="[pdfData]"
        >
        </PdfLayout>

        <EditInteraction
            ref="editInteraction"
            :usersMentionList="usersMentionList"
            v-on:saved="activitySaved"
        >
        </EditInteraction>

        <EditNote
            ref="editNote"
            company-type="startup"
            :company-id="id"
            v-on:saved="activitySaved"
        >
        </EditNote>

        <EditArticle
            :startup-id="id"
            ref="editArticle"
            v-on:saved="activitySaved"
        >
        </EditArticle>

        <Invite
            ref="invite"
        >
        </Invite>

        <ErrorReport
            ref="errorReport"
            :startup-id="id"
        >
        </ErrorReport>

        <add-task
            ref="addTask"
            :startup-id="id"
            prefix="-startup"
            v-on:task-saved="getActivities"
        >
        </add-task>

        <SelectCategories
            :exclude-categories="arrayHelper.arrayColumn(commonData.categories,'id')"
            ref="SelectCategories"
            v-on:categoriesSelected="addCategories"
        >
        </SelectCategories>

        <SetLocation
            ref="SetLocation"
            v-on:locationSelected="setLocation"
        >
        </SetLocation>
    </div>
</template>

<script>

import startups from "@/services/startups.service"
import customFields from "@/services/custom-fields.service"
import customField from "@/components/customFields/CustomField"
import VClamp from "vue-clamp"
import Avatar from "vue-avatar"
import editTracker from "@/components/trackers/EditTracker"
import editContact from "@/components/contacts/EditContact"
import AddToTrackers from "@/components/manage/SelectTrackers";
import SelectCategories from "@/components/manage/SelectCategories";
import SetLocation from "@/components/manage/SelectLocation";
import trackersStartups from "@/services/trackers-startups.service";
import trackers from "@/services/trackers.service";
import AddTags from "@/components/manage/AddTags";
import tags from "@/services/tags.service";
import FundingRounds from "@/components/startups/FundingRounds";
import PdfLayout from "@/components/startups/PdfLayout";
import actionLogs from "@/services/action-logs.service";
import contacts from "@/services/contacts.service";
import EditInteraction from "@/components/interactions/EditInteractionModal";
import AddInteraction from "@/components/interactions/EditInteractionInline";
import EditNote from "@/components/notes/EditNoteModal";
import AddNote from "@/components/notes/EditNoteInline";
import Invite from "@/components/startups/InviteStartup";
import ErrorReport from "@/components/AddErrorReport";
import TasksList from "@/components/tasks/List";
import team from "@/services/team.service";
import AddTask from "@/components/tasks/EditTask";
import user from "@/services/user.service";
import EditArticle from "@/components/articles/EditArticleModal";
import AddArticle from "@/components/articles/EditArticleInline";
import articles from "@/services/articles.service";
import exports from "@/services/exports.service";

  export default {
      components: {
          customField,
          VClamp,
          Avatar,
          editTracker,
          editContact,
          AddToTrackers,
          AddTags,
          FundingRounds,
          PdfLayout,
          EditInteraction,
          AddInteraction,
          EditNote,
          AddNote,
          Invite,
          ErrorReport,
          TasksList,
          AddTask,
          EditArticle,
          AddArticle,
          SelectCategories,
          SetLocation,
      },

      data() {
          return {
              id: parseInt(this.$route.params.id),
              loaded: false,
              tags: [],
              news: [],
              investors: [],
              commonData: {},
              customData: {},
              ecosystemsData: [],
              trackers: [],
              customFields: [],
              contacts: [],
              contactsTotalCount: 0,
              contactsSearch: "",
              activities: [],
              newNote: "",
              fundingRounds: [],
              tasksCount: 0,

              trackersList: [],
              tagsList: [],

              filledFieldsPerc: null,
              pdfData: {},
              interactionType: 'note',

              tasksListType: '',
              groups: [],
              openTasksTypeSelect: false,
              tasksShowCompleted: false,
              taskSearch: "",

              activityOrder: 'created_at',
              openActivityOrderSelect: false,
              activityOrderTypes: {
                  'created_at': 'Date added',
                  'interaction_date': 'Interaction date',
              },

              activityFilter: '',
              openActivityFilterSelect: false,
              activityFilterTypes: {
                  '': 'All Activity',
                  'news': 'News',
                  'cb_changes': 'SwitchPitch updates',
                  'notes': 'Notes',
                  'interactions': 'Interactions',
                  'users_activity': 'Users activity',
              },

              usersMentionList: [],
              mentionApplied: false,
              noteInputDisabled: false,
          }
      },

      mounted() {
          this.getData()

          this.$store.watch(state => {
              if (state.needUpdateTrackers) {
                  this.getTrackersList()
              }

              if (state.needUpdateUsers) {
                  this.updateUsersList()
              }

              if (state.needUpdateTasks) {
                  this.getTasksCount()
                  this.getActivities()
              }
          })

          if (this.$store.state.user.is_admin) {
              team.getGroupsList().then(response => {
                  this.groups = response.data
              })
          }

          this.getUsersMentionList()
      },

      watch: {
          contactsSearch() {
              this.getContacts()
          },
      },

      computed: {
          otherTrackersList() {
              let array = []
              let existed = this.arrayHelper.arrayColumn(this.trackers, 'id')
              this.trackersList.forEach(item => {
                  if (existed.indexOf(item.value) < 0) {
                      array.push(item)
                  }
              })

              return array
          },

          location() {
              let str = []

              if (this.commonData.city) {
                  str.push(this.commonData.city)
              }

              if (this.commonData.state) {
                  str.push(this.commonData.state)
              }

              if (this.commonData.country) {
                  str.push(this.commonData.country)
              }

              if (this.commonData.continent) {
                  str.push(this.commonData.continent)
              }

              return str.join(', ')
          },

          addTagsList() {
              let array = []
              this.tagsList.forEach(item => {
                  if (!this.arrayHelper.exists(this.tags, 'id', item.value)) {
                      array.push(item)
                  }
              })

              return array
          },

          revenueRange() {
              let string = this.commonData.revenue_range
              string = string.replace('Less than', '<')
              string = string.replace('Greater than', '>')
              return string
          },

          taskListTypes() {
              let list = {}
              list['my'] = 'Me'
              if (this.$store.state.user.is_admin) {
                  this.groups.forEach(item => {
                      list['group-' + item.id] = item.name
                  })

                  list['all'] = 'Everyone'
              }
              else {
                  list['team'] = 'Teams'
              }

              return list
          }
      },

      methods: {
          getData() {
              customFields.getFieldsWithSections('company_diligence').then(response => {
                  this.customFields = response.data
              })

              startups.getCommonData(this.id).then(response => {
                  if (typeof response.data.merged_to !== 'undefined') {
                      window.location.href = '/startups/' + response.data.merged_to
                  }
                  else {
                      this.commonData = response.data
                      document.title = this.commonData.name + ' | SwitchPitch'
                      this.fundingRounds = this.commonData.funding_rounds
                      this.loaded = true
                  }

                  startups.getEcosystemsData(this.id).then(response => {
                      this.ecosystemsData = response.data
                  })

                  startups.getCustomData(this.id, 'company_diligence').then(response => {
                      this.customData = response.data
                      this.calculateFilledFields()
                  })

                  this.getTags()

                  tags.getList().then(response => {
                      this.tagsList = response.data
                  })


                  startups.getInvestors(this.id).then(response => {
                      this.investors = response.data
                  })

                  this.getTrackers()
                  this.getContacts()
                  this.getNews()

                  this.getActivities()
                  this.getTrackersList()
              })

              this.getTasksCount()

              user.getTaskType(this.id, 0).then(response => {
                  this.tasksListType = response.data
              })
          },

          getNews() {
              startups.getNews(this.id).then(response => {
                  this.news = response.data
              })
          },

          getTrackersList() {
              trackers.getListForStartupAdd().then(response => {
                  this.trackersList = response.data
              })
          },

          calculateFilledFields() {
              let allCount = 0
              let filledCount = 0

              for (let i in this.customData) {
                  ++allCount
                  let value = this.customData[i]

                  if (this.fieldIsFilled(value)) {
                      ++filledCount
                  }
              }

              this.filledFieldsPerc = Math.round(filledCount / allCount * 100)
          },

          fieldIsFilled(value) {
              if (value.value.length || value.options.length || value.files.length || value.links.length) {
                  return true
              }
              else {
                  return false
              }
          },

          getTags() {
              startups.getTags(this.id).then(response => {
                  this.tags = response.data
              })
          },

          getTrackers() {
              startups.getTrackers(this.id).then(response => {
                  this.trackers = response.data
              })
          },

          getContacts() {
              startups.getContacts(this.id, this.contactsSearch).then(response => {
                  this.contacts = response.data

                  if (!this.contactsSearch.length) {
                      this.contactsTotalCount = this.contacts.length
                  }
              })
          },

          getActivities() {
              startups.getActivities(this.id, {sort: this.activityOrder, filter: this.activityFilter}).then(response => {
                  this.activities = response.data
              })
          },

          getTasksCount() {
              startups.getTasksCount(this.id).then(response => {
                  this.tasksCount = response.data
              })
          },

          closeDescriptionPopover() {
              this.$refs.descriptionPopover.$emit('close')
          },

          customValueChanged(fieldId) {
              this.getActivities()
              startups.getCustomData(this.id, 'company_diligence').then((response) => {
                  this.customData[fieldId] = response.data[fieldId]
                  this.calculateFilledFields()
              })
          },

          showContactInfo(id) {
              this.$refs.editContact.open(id)
          },

          addContact() {
              this.$refs.editContact.open(0, this.id)
          },

          deleteContact(id) {
              if (confirm("Delete contact?")) {
                  contacts.delete(id).then(() => {
                      this.getContacts()
                  })
              }
          },

          openAddToTrackers() {
              this.$refs.addToTrackers.open()
          },

          addToTrackers(addedTrackers) {
              let trackersIds = this.arrayHelper.arrayColumn(addedTrackers, 'value')
              trackersStartups.addStartups([this.id], trackersIds).then(() => {
                  this.getTrackers()
                  this.getActivities()
              })
          },

          removeFromTracker(trackerId) {
              trackersStartups.removeStartups([this.id], [trackerId]).then(() => {
                  this.getTrackers()
                  this.getActivities()
              })
          },

          getActivityIconClass(activity) {
              if (activity.type == 'note') {
                  return 'activity-list__title--note'
              }
              else if (activity.type == 'phone_call') {
                  return 'activity-list__title--call'
              }
              else if (activity.type == 'email') {
                  return 'activity-list__title--email'
              }
              else if (activity.type == 'meeting') {
                  return 'activity-list__title--meeting'
              }
              else {
                  return 'activity-list__title--' + activity.type
              }
          },

          activitySaved() {
              this.getActivities()
          },

          addTask() {
              if (this.newNote.length) {
                  this.$refs.addTask.open(0)
              }
          },

          openAddTags() {
              this.$refs.addTags.open()
          },

          addTags(addedTags) {
              let tagsIds = this.arrayHelper.arrayColumn(addedTags, 'value')
              tags.addTags([this.id], tagsIds).then(() => {
                  this.getTags()
                  this.$refs.addTags.close()
                  this.getActivities()
              })
          },

          removeTag(tagId) {
              let removedTags = [tagId]
              let startups = [this.id]
              tags.removeTags(startups, removedTags).then(() => {
                  this.getTags()
                  this.getActivities()
              })
          },

          showFundingRounds() {
              this.$refs.fundingRounds.open(this.id)
          },

          generateReport () {
              startups.getDataForPdf(this.id).then(response => {
                  this.pdfData = response.data
                  this.$refs.pdfLayout.generatePdf()
              })
          },

          removeActivity(logId) {
              if (confirm("Remove activity?")) {
                  actionLogs.removeActivity(logId).then(() => {
                      this.getActivities()
                  })
              }
          },

          editActivity(activity) {
              if (activity.object_type == 'startup-note') {
                  this.$refs.editNote.open(activity.object_id)
              }

              else if (activity.object_type == 'interaction') {
                  this.$refs.editInteraction.open(activity.object_id)
              }
          },

          copyProfileLink() {
              let link = this.$api.defaults.baseURL;
             if (this.$store.state.user.company_id == this.constants.companyPfizer) {
                 link = link + '/pfizer-saml/login?returnTo=startups/' + this.id;
             } else if(this.$store.state.user.company_id == this.constants.companyColgate){
                 link = link + '/colgate-saml/login?returnTo=startups/' + this.id;
             } else {
                 link = document.location.origin + '/startups/' + this.id
             }
             navigator.clipboard.writeText(link)
          },

          editContact(id) {
              this.$refs.editContact.open(id, 0, 0, true)
          },

          exportTasks() {
              this.$refs.tasksList.exportCSV()
          },

          addArticle() {
              this.$refs.editArticle.open(0)
          },

          removeArticle(id) {
              if (confirm("Remove article?")) {
                  articles.delete(id).then(() => {
                      this.activitySaved()
                  })
              }
          },

          editArticle(id) {
              this.$refs.editArticle.open(id)
          },

          getUsersMentionList() {
              team.getUsersMentionList().then(response => {
                  this.usersMentionList = response.data
              })
          },

          addCategories(categories) {
              startups.addCategories(this.id, {categories: this.arrayHelper.arrayColumn(categories, 'value')}).then(() => {
                  this.getData()
              })
          },

          setLocation(location) {
              startups.setLocation(this.id, {location: location}).then(() => {
                  this.getData()
              })
          },

          exportContacts() {
              exports.exportStartupsContacts([this.id]).then(response => {
                  this.fileHelper.download(response.data, 'contacts.csv')
              })
          },

          updateUsersList() {
              for (let sectionId in this.customFields) {
                  this.customFields[sectionId].fields.forEach(field => {

                      if (field.field_type == 'users_list') {

                          customFields.getOptions(field.id).then(response => {
                              field.options = response.data.options
                              field.options_list = response.data.options_list
                          })
                      }
                  })
              }
          }
      }
  }
</script>

<style scoped>

</style>